export class InfinityScroll {
    constructor(callback) {
        this.spaceBefore = 2 * window.innerHeight;
        this.callback = callback;
        this.lastPositionCallback = 0;

        this.onScroll();
        this.onResize();
    }

    onScroll() {
        const {spaceBefore, callback} = this;
        this.onScrollFn = () => {
            const currentScroll = document.documentElement.scrollTop;
            const maxScroll = document.body.scrollHeight;

            const current = currentScroll + spaceBefore;

            if(current >= maxScroll && current > (this.lastPositionCallback + spaceBefore)) {
                this.lastPositionCallback = current; // for call callback only once while maxScroll unchange
                if(typeof callback === 'function') callback();
            }
        }

        window.addEventListener('scroll', this.onScrollFn);
    }

    onResize() {
        this.onResizeFn = () => {
            this.lastPositionCallback = 0;
        }

        window.addEventListener('resize', this.onResizeFn);
    }

    remove() {
        window.removeEventListener('resize', this.onResizeFn);
        window.removeEventListener('scroll', this.onScrollFn);
    }

    reset() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        this.lastPositionCallback = 0;
    }
}


// WEBPACK FOOTER //
// ./src/helper/infinityScroll.js